import { render, staticRenderFns } from "./SubTitleText.vue?vue&type=template&id=3d66d015&"
import script from "./SubTitleText.vue?vue&type=script&lang=js&"
export * from "./SubTitleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports